import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'เราใช้คุกกี้',
    description:
      'เราใช้คุกกี้และเทคโนโลยีที่คล้ายกันเพื่อให้บริการประสบการณ์นี้ คุกกี้ที่จำเป็นอย่างยิ่งจะเปิดใช้งานอยู่เสมอ',
    allow_label: 'ยอมรับคุกกี้ทั้งหมด',
    reject_label: 'เฉพาะคุกกี้ที่จำเป็นอย่างยิ่ง',
    settings_label: 'การตั้งค่าคุกกี้',
    policy_link_label: 'นโยบายความเป็นส่วนตัวและคุกกี้',
    categories_label: 'หมวดหมู่',
    always_on_label: 'เปิดใช้งานอยู่เสมอ',
    required_label: 'จำเป็น',
    save_preferences_label: 'บันทึกการตั้งค่า',
    close_label: 'ปิด',
    allow_all_optional_categories_label: 'อนุญาตหมวดหมู่ตัวเลือกทั้งหมด',
    settings_title: 'การตั้งค่าคุกกี้',
    settings_description:
      'เราใช้คุกกี้และเทคโนโลยีที่คล้ายกันเพื่อให้บริการประสบการณ์นี้ คุกกี้ที่จำเป็นอย่างยิ่งจะเปิดใช้งานอยู่เสมอ',
    save_error: 'ไม่สามารถบันทึกตัวเลือกความเป็นส่วนตัวของคุณได้ โปรดลองอีกครั้ง'
  },
  categories: {
    strictly_necessary: {
      name: 'จำเป็นอย่างยิ่ง',
      purpose: 'จำเป็นสำหรับการให้บริการประสบการณ์นี้และไม่สามารถปิดใช้งานได้'
    },
    analytics: {
      name: 'การวิเคราะห์',
      purpose: 'วัดวิธีที่ผู้เข้าชมใช้ประสบการณ์นี้เพื่อปรับปรุงประสิทธิภาพ'
    },
    marketing: { name: 'การตลาด', purpose: 'สนับสนุนการโฆษณาและการตลาดที่ผู้จัดงานเลือก' }
  }
};

export default locale;
